import { useCallback } from 'react';
import axios from 'axios';
import yaml from 'yaml';

export interface ConfigType {
  name: string;
  url: string;
}

export default function useYamlParse() {
  return useCallback(async (url: string) => {
    try {
      const { data } = await axios.get(url);
      return yaml.parse(data);
    } catch (e) {
      console.error(e);
    }
  }, []);
}
